var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-primary d-inline-flex align-items-center"},[_c('span',{staticClass:"badge badge-light text-dark"},[_vm._v(_vm._s(_vm.entity.type))]),_c('span',{staticClass:"ml-0-5"},[_vm._v(_vm._s(_vm.entity.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }